module.exports = __webpack_public_path__ + "img/m-icon9.264b3cff.png";